export const configurationColumnTableFAPioneerFields = {
  activityDate: true,
  done: true,
  type: true,
  fieldNames: true,
  groupNames: false,
  commodity: true,
  productNames: true,
  userNames: true,
  tractorNames: true,
  equipmentNames: true,
  machineActivities: true,
  files: false,
  note: false,
  fromDate: false,
  toDate: false,
  infestationLevel: false,
  interventionReason: false,
  temperature: false,
  humidity: false,
  wind: false,
  rainLast24h: false,
  fieldTags: false,
  subunit: false,
  checks: false,
  phenologicalStage: false,
  title: true,
};
